import { EquipmentItem } from "@/backend/models/equipmentItem";
import { useState } from "react";
import { Form, Modal } from "react-bootstrap";
import { useEquipmentStore } from "@/frontend/store/EquipmentStore";
import { useParameterStore } from "@/frontend/store/ParameterStore";
import { ButtonParent } from "../buttons/ButtonParent";
import { I18n } from "@/i18n/I18n";
import { CustomFieldDropdown } from "../customFIelds/CustomFieldDropdown";
import { Gear } from "@/frontend/SVGs/Gear";
import { ObjectKeyVisibility } from "@/types/customFieldTypes";
import { NeutralDeleteButton } from "../buttons/NeutralDeleteButton";
import { ObjectKeyInput } from "../customFIelds/customFieldObjects/ObjectKeyInput";
import { ObjectValueEditForm } from "../customFIelds/customFieldObjects/ObjectValueEditForm";

export function EquipmentConfigModal(props: { item: EquipmentItem }) {
  const { item } = props;
  const [showModal, setShowModal] = useState(false);
  const fetchEquipmentItem = useEquipmentStore(state => state.fetchEquipmentItem);
  const addObjectKey = useParameterStore(state => state.addObjectKey);
  const deleteObjectKey = useParameterStore(state => state.deleteObjectKey);

  const objectInstance = item.defaultConfiguration.objectInstance;
  const handleUpdatedConsumers = () => {
    void fetchEquipmentItem(item.id);
  };

  return (
    <>
      <ButtonParent
        className='btn btn-sm btn-light'
        onClick={() => setShowModal(true)}
        title={I18n.get('editModel', { model: I18n.get('equipment'), title: `${item.name} Default Configuration` })}
      >
        <Gear />
      </ButtonParent>
      <Modal size='xl' show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{I18n.get('editDefaultConfigurationFor', { equipmentName: item.name })}</Modal.Title>
        </Modal.Header >
        <Modal.Body>
        <div className='d-flex flex-column gap-3'>
            {objectInstance.properties.map(property => <div className="d-flex gap-2 mb-2" key={property.keyId}>
              <ObjectKeyInput property={property} properties={objectInstance.properties} handleUpdatedConsumers={handleUpdatedConsumers} />
              <div className='flex-fill w-100'>
                <Form.Label className="form-label-neutral">{I18n.get('value')} <small className='text-muted text-uppercase'>{`(${I18n.get(property.type)})`}</small></Form.Label>
                <ObjectValueEditForm property={property} handleUpdatedConsumers={handleUpdatedConsumers} />
              </div>
              <div className='d-flex align-items-end'><NeutralDeleteButton onSubmit={() => deleteObjectKey(property.keyId, handleUpdatedConsumers)} itemType={I18n.get('property')} title='' /></div>
            </div>)}
          </div>
          <CustomFieldDropdown onClick={(type) => void addObjectKey({ objectShapeId: item.defaultConfiguration.objectInstance.objectShapeId, type, visibility: ObjectKeyVisibility.EDITABLE }, () => void fetchEquipmentItem(item.id))} label={I18n.get('addProperty')} />
        </Modal.Body>
      </Modal>
    </>
  );
}
